import { SimpleQueryResponse } from './../dtos/simpleQueryResponse';
import { SessionService } from './session.service';
import { SimpleQueryUser } from './../dtos/simpleQueryUser';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { APICONSTANTS } from './../constants/api-constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericCrudService } from './basic/generic.crud.service';
import { UtilisateurModel } from '../models/utilisateur/utilisateur.model';
import { ToastrService } from 'ngx-toastr';
import { HostnameService } from './basic/hostname.service';
import { UserModelDTO } from '../dtos/userModelDTO';
import { UpdateDroitResponse } from '../dtos/updateDroitResponse';

@Injectable()
export class UserService extends GenericCrudService<UtilisateurModel> {
  protected header: HttpHeaders;

    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEUSER, hostnameService);
  }

  getFromSimpleQuery(objet: SimpleQueryUser): Observable<SimpleQueryResponse<UtilisateurModel>> {
    // tslint:disable-next-line: max-line-length
    return this.http.post<SimpleQueryResponse<UtilisateurModel>>(APICONSTANTS.URLAPI.value + this.route + 'GetFromSimpleQuery/', objet, {headers: this.header});
  }
  getAllActif(): Observable<UtilisateurModel[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<UtilisateurModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllActif/').pipe(catchError( err => this.requestCatchError(err, 'GetAllActif')));
  }

  getAllCreateur(type: string): Observable<UtilisateurModel[]> {
    return this.http.get<UtilisateurModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllCreateur/' + type)
        .pipe(catchError(err => this.requestCatchError(err, 'Createurs')));
  }

  getAllValideur(type: string): Observable<UtilisateurModel[]> {
    return this.http.get<UtilisateurModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllValideur/' + type)
        .pipe(catchError(err => this.requestCatchError(err, 'Valideurs')));
  }

  updateUserAndDroit(objet: UserModelDTO): Observable<UpdateDroitResponse> {
    // tslint:disable-next-line: max-line-length
    return this.http.post<UserModelDTO>(APICONSTANTS.URLAPI.value + this.route + 'updateUserAndDroit/', objet)
      .pipe(catchError(err => this.requestCatchError(err, 'Mise à jour de l\'utilisateur')));
  }

  updateUserAndDroitDelegation(objet: UserModelDTO): Observable<UpdateDroitResponse> {
    // tslint:disable-next-line: max-line-length
    return this.http.post<UserModelDTO>(APICONSTANTS.URLAPI.value + this.route + 'updateUserAndDroitDelegation/', objet)
      .pipe(catchError(err => this.requestCatchError(err, 'Mise à jour de l\'utilisateur')));
  }

  getAllStandardFromBC(idSociete: number, niveau: number, codeCa1: string): Observable<UtilisateurModel[]> {
    return this.http.get<UtilisateurModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllStandardFromBC?idSociete='+ idSociete + '&niveau=' + niveau + '&codeCa1=' + codeCa1)
        .pipe(catchError(err => this.requestCatchError(err, 'Utilisateurs standard')));
  }

  getAllDelegFromBC(idSociete: number, niveau: number, codeCa1: string): Observable<UtilisateurModel[]> {
    return this.http.get<UtilisateurModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllDelegFromBC?idSociete='+ idSociete + '&niveau=' + niveau + '&codeCa1=' + codeCa1)
        .pipe(catchError(err => this.requestCatchError(err, 'Utilisateurs Deleg')));
  }
}
